import { createContext, useCallback, useState } from "react";
import API from "services/api";

export const MemberContext = createContext({});

const MemberProvider = (props) => {
  const [totalCount, setTotalCount] = useState(0);
  const [dataChapter, setDataChapter] = useState([]);
  const [dataOrganizationUnit, setDataOrganizationUnit] = useState([]);
  const [dataMembership, setDataMembership] = useState({});
  const getMemberContent = useCallback(async (params) => {
    try {
      const { status, ...otherParams } = params; 
      const res = await API.getMembershipByStatus(status, otherParams);
      const { data, totalCount } = res.data;
  
      setDataMembership(data);
      setTotalCount(totalCount);
    } catch (err) {
      console.log("err", err);
    }
  }, []);
  const getChapterContent = useCallback(async (params) => {
    try {
      const res = await API.getAllChapter(params);
      const { data, totalCount } = res.data;
  
      setDataChapter(data);
      setTotalCount(totalCount);
    } catch (err) {
      console.log("err", err);
    }
  }, []);
  const getOrganizationUnit = useCallback(async (params) => {
    try {
      const res = await API.getAllOrganizationalUnit(params);
      const { data, totalCount } = res.data;
  
      setDataOrganizationUnit(data);
      setTotalCount(totalCount);
    } catch (err) {
      console.log("err", err);
    }
  }, []);
return (
    <MemberContext.Provider
      value={{
        dataMembership,
        dataChapter,
        dataOrganizationUnit,
        getMemberContent,
        getChapterContent,
        getOrganizationUnit,
        totalCount,
      }}
      {...props}
    />
  );
};
export default MemberProvider;